import { render, staticRenderFns } from "./EmailTrackingDetailWidget.vue?vue&type=template&id=b1b63ec6&scoped=true&"
import script from "./EmailTrackingDetailWidget.vue?vue&type=script&lang=js&"
export * from "./EmailTrackingDetailWidget.vue?vue&type=script&lang=js&"
import style0 from "./EmailTrackingDetailWidget.vue?vue&type=style&index=0&id=b1b63ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b63ec6",
  null
  
)

export default component.exports